
import React, { useEffect, useState } from "react";
import Moment from 'react-moment';
import moment from 'moment';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import DateTimePicker from '@mui/lab/DateTimePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker'
import TextField from '@mui/material/TextField';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TableRowsIcon from '@mui/icons-material/TableRows';
import HistoryIcon from '@mui/icons-material/History';
import authHeader from "../services/auth-header";

//import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';
//import { Link } from 'react-router-dom';
import { useParams } from "react-router-dom";
import DetectorsByParking from '../detectors/DetectorsByParking';

import { useTranslation } from "react-i18next";

const api = require("../api/names.js");


function ParkingDetails(props) {

  const { t } = useTranslation("common");

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    //const [itemsStateChanged, setItemsStateChanged] = useState([]);
    //const [dateMin, setDateMin] = useState(new Date(Date.now() - (1*24*60*60*1000)));
    //const [dateMax, setDateMax] = useState(new Date());

    const params = useParams();
    useEffect(() => {

      var url = api.baseUrl+'/parkings/';
      url += params.parkingID;
      //console.log(url);
      fetch(url, {
    method: 'get',
    headers: authHeader()
    })
      .then(res => res.json())
      .then(
        (result) => {
          //console.log(result);
          setIsLoaded(true);
          setItems(result);

        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )


    },[])

    function seconds2time (seconds) {
        var hours   = Math.floor(seconds / 3600);
        var minutes = Math.floor((seconds - (hours * 3600)) / 60);
        var seconds = seconds - (hours * 3600) - (minutes * 60);
        var time = "";

        if (hours != 0) {
          time = hours+"h ";
        }
        if (minutes != 0 || time !== "") {
          minutes = (minutes < 10 && time !== "") ? "0"+minutes : String(minutes);
          time += minutes+"min ";
        }
        if (time === "") {
          time = seconds+"s";
        }
        else {
          time += (seconds < 10) ? "0"+seconds : String(seconds)+"s";
        }
        return time;
    }

    if (error) {
       return <div>{t('detectord.error')}{error.message}</div>;
     } else if (!isLoaded) {
      return <div>{t('detectord.loading')}</div>;
     } else {
       return (

          <div>
          <br/>
           <div style={{ display: "flex" }}>
            <Button href='/parkings' variant="outlined" startIcon={<ArrowBackIcon />}>
              {t('parkingd.comeback')}
            </Button>
            <Button href={'/parkingStats/' + params.parkingID} style={{ marginLeft: "auto" }} variant="outlined" startIcon={<HistoryIcon />}>
              {t('parkinglist.historical')}
            </Button>
          </div>
      {/*   <Button href={'/detectorsTable/'+params.parkingID} variant="outlined" startIcon={<TableRowsIcon />}>
         ALL DETECTORS IN TABLE
         </Button> */}
         <br/>
         <Accordion
         expanded={true}
         >
          <AccordionSummary

             expandIcon={<ExpandMoreIcon />}
             aria-controls="panel2a-content"
             id="panel2a-header"
           >
               <Typography>{t('parkingd.details')}</Typography>
           </AccordionSummary>
           <AccordionDetails>
           Parking: {items.parkingName+" ("+items.description+")"}
           </AccordionDetails>
         </Accordion>


           <DetectorsByParking parkingID = {items.parkingID} gpsLatitude = {items.gpsLatitude} gpsLongtitude = {items.gpsLongtitude}/>





        </div>
       );
     }
   }

export default ParkingDetails;
